// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1eH9F","validationTips":"StatementDescriptor_validationTips__36TNh"};